import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// Slice name
const name = "validateUserEmail";

// Create slice
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// Exports
export const validateUserEmailActions = { ...slice.actions, ...extraActions };
export const validateUserEmailReducer = slice.reducer;

// Implementation

function createInitialState() {
  return {
    userExists: null,
    loading: false,
    error: null,
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/LoginUser`;

  return {
    checkUserNameEmailExists: createAsyncThunk(
      `${name}/checkUserNameEmailExists`,
      async ({ userName = "", email = "" }, { rejectWithValue }) => {
        try {
          if (userName?.trim()?.length == 0 && email?.trim()?.length == 0) return;
          // Construct the query string with explicit empty values in quotes
          const queryParams = new URLSearchParams({
            userName: userName || "''", // Ensure empty strings if not provided
            email: email === "" ? "''" : email, // Explicitly handle empty string as "''"
          }).toString();

          const response = await fetchWrapper.get(
            `${baseUrl}/CheckUserNameEmailExists?${queryParams}`
          );
          return response; // This will be passed as the action.payload in fulfilled case
        } catch (error) {
          return rejectWithValue(error.message || "Something went wrong"); // Handle error
        }
      }
    ),
  };
}

function createExtraReducers(builder) {
  const { checkUserNameEmailExists } = extraActions;

  builder
    .addCase(checkUserNameEmailExists.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(checkUserNameEmailExists.fulfilled, (state, action) => {
      state.loading = false;
      state.userExists = action.payload;
      state.error = null;
    })
    .addCase(checkUserNameEmailExists.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
}
